import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../../../components/Footer';
import {
    MonitorPlay,
    Building,
    Wrench,
    Rocket,
    Stars,
    Briefcase,
    GraduationCap,
    ChevronRight, BookOpen,
    Award, Users, Globe,
    Clock, Bookmark, Share2, ArrowUpRight,
    Target, // for Vision
    Flag, // for Mission
    HelpCircle, // for Why Study
    Award as UniqueIcon // for What Makes Unique

} from 'lucide-react';
import { Link } from 'react-router-dom';
import Title from '../../../components/TitleComponent';

const DiplomaPrograms = [
    {
        name: "Diploma in Civil Engineering",
        path: "/programmes/ug-courses/engineering/btech/cloud-computing-engineering"
    },
    {
        name: "Diploma in Computer Science & Engineering",
        path: "/programmes/ug-courses/engineering/btech/data-science-engineering"
    },
    {
        name: "Diploma in Electronics and Communication Engineering",
        path: "/programmes/ug-courses/engineering/btech/cybersecurity-engineering"
    },
    {
        name: "Diploma in Mechanical Engineering",
        path: "/programmes/ug-courses/engineering/btech/ai-ml"
    },

]

const undergraduatePrograms = [

    // {
    //     name: "Bachelor of Technology in Cloud Computing and Engineering",
    //     path: "/programmes/ug-courses/engineering/btech/cloud-computing-engineering"
    // },
    // {
    //     name: "Bachelor of Technology in Data Science and Engineering",
    //     path: "/programmes/ug-courses/engineering/btech/data-science-engineering"
    // },
    // {
    //     name: "Bachelor of Technology in Cyber Security and Engineering",
    //     path: "/programmes/ug-courses/engineering/btech/cybersecurity-engineering"
    // },
    // {
    //     name: "Bachelor of Technology in Artificial Intelligence Machine Learning and Engineering",
    //     path: "/programmes/ug-courses/engineering/btech/ai-ml"
    // },
    {
        name: "Bachelor of Technology in Civil Engineering (Structural Engineering)",
        path: "/api"
    },
    {
        name: "Bachelor of Technology in Civil Engineering",
        path: "/programmes/ug-courses/engineering/btech/civil-engineering"
    },
    {
        name: "Bachelor of Technology in Computer Science and Engineering",
        path: "/programmes/ug-courses/engineering/btech/computer-science-engineering"
    },
    {
        name: "Bachelor of Technology in Mechanical Engineering",
        path: "/programmes/ug-courses/engineering/btech/mechanical-engineering"
    },
    {
        name: "Bachelor of Technology in Mechanical Engineering with Mechatronics",
        path: "/programmes/ug-courses/engineering/btech/mechatronics-and-robotics"
    },
    {
        name: "Bachelor of Technology in Electronics and Communication Engineering(ECE)",
        path: "/api"
    },
    {
        name: "Bachelor of Technology in Electronics and Communication Engineering(Robotics & AI)",
        path: "/api"
    },
    {
        name: "Bachelor of Technology in Electronics and Communication Engineering(VLSI & Embeded System)",
        path: "/api"
    },
    {
        name: "Bachelor of Technology(LE) in (Mechanical Engineering, Civil Engineering,  and Electronics and Communication Engineering)",
        path: "/api"
    },
    {
        name: "Bachelor of Technology Aerospace Engineering",
        path: "/api"
    },
]

const PostgraduatePrograms = [
    // {
    //     name: "Master of Technology in Thermal Engineering",
    //     path: "/programmes/pg-courses/engineering/mtech/thermal-engineering"
    // },
    // {
    //     name: "Master of Technology in Production Engineering",
    //     path: "/programmes/pg-courses/engineering/mtech/production-engineering"
    // },
    // {
    //     name: "Master of Technology in Renewable Energy",
    //     path: "/programmes/pg-courses/engineering/mtech/renewable-energy"
    // },
    // {
    //     name: "Master of Technology in Electric Vehicle  Technology",
    //     path: "/programmes/pg-courses/engineering/mtech/electric-vehicle"
    // },
    {
        name: "Master of Technology in Structural Engineering",
        path: "/programmes/pg-courses/engineering/mtech/structural-engineering"
    },
    {
        name: "Master of Technology in Mechanical Engineering",
        path: "/programmes/pg-courses/engineering/mtech/Mechanical-engineering"
    },
    // {
    //     name: "Master of Technology in Transportation Engineering",
    //     path: "/programmes/pg-courses/engineering/mtech/transportation-engineering"
    // },
    // {
    //     name: "Master of Technology in Data Science and Engineering",
    //     path: "/programmes/pg-courses/engineering/mtech/data-science-engineering"
    // },
    // {
    //     name: "Master of Technology in Artificial Intelligence Machine Learning and Engineering",
    //     path: "/programmes/pg-courses/engineering/mtech/ai-ml"
    // },
    // {
    //     name: "Master of Technology in Digital Communication Engineering",
    //     path: "/programmes/pg-courses/engineering/mtech/digital-communication"
    // },

]



const Stats = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 my-4 md:my-8 px-4"
    >
        {[
            { icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, number: "5000+", label: "Students Enrolled", color: "bg-blue-50" },
            { icon: <BookOpen className="w-6 h-6 md:w-8 md:h-8" />, number: "50+", label: "Programs Offered", color: "bg-green-50" },
            { icon: <Award className="w-6 h-6 md:w-8 md:h-8" />, number: "95%", label: "Placement Rate", color: "bg-purple-50" },
            { icon: <Globe className="w-6 h-6 md:w-8 md:h-8" />, number: "100+", label: "Industry Partners", color: "bg-orange-50" }
        ].map((stat, index) => (
            <motion.div
                key={index}
                className={`${stat.color} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300`}
                whileHover={{ scale: 1.02 }}
            >
                <div className="text-[#0e4d38]">{stat.icon}</div>
                <h3 className="text-xl md:text-2xl font-bold mt-2 text-gray-800">{stat.number}</h3>
                <p className="text-gray-600 text-xs md:text-sm">{stat.label}</p>
            </motion.div>
        ))}
    </motion.div>
);


const AboutSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <BookOpen className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">About the School of Engineering</h4>
        </div>
        <div className="space-y-4 text-gray-700">
            <p>Engineering is one of the foundational fields of technical study, playing a crucial role in setting global standards of excellence across various disciplines of science and technology. It has significantly contributed to society's progress, offering countless innovations and improving the welfare of humanity. The Faculty of Engineering and Technology is dedicated to shaping and nurturing the next generation of engineers and technical experts. These professionals not only drive technological advancements but also make important contributions to life sciences and beyond. At the heart of engineering lies a spirit of innovation, as engineers tackle challenges and create breakthrough solutions. </p>

            <p>MDU is a premier engineering institution committed to nurturing innovative minds and shaping future leaders. With a strong emphasis on academic excellence, research, and industry collaboration, we offer a wide range of undergraduate and postgraduate programs in cutting-edge engineering disciplines. Our state-of-the-art infrastructure, experienced faculty, and industry partnerships provide our students with a holistic learning experience, preparing them to excel in a rapidly evolving technological landscape. </p>

            <p>With a distinguished team of faculty members, we focus on developing students who are passionate about serving society through innovative technology and who possess strong interpersonal skills. Our faculty ensures a holistic learning experience by offering a wide range of academic opportunities, including expert talks, seminars, workshops, and industrial visits. In response to the rapidly evolving technological landscape, we actively create platforms for students to showcase their engineering innovations through exhibitions and hands-on projects, enabling them to learn, grow, and shape the future of engineering.
            </p>
        </div>
    </motion.div>
);

const VisionMissionSection = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Target className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Vision</h4>
            </div>
            <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>To develop highly skilled professionals to man positions in the industry responding to technological and scientific advancements.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>To be a premier institution of technical education and research, producing globally competent engineers who are innovative, ethical, and socially responsible, driving technological advancement and contributing to the sustainable development of society. </span>
                </li>
            </ul>
        </motion.div>

        <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Flag className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Mission</h4>
            </div>
            <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>To develop highly skilled professionals to man positions in the industry responding to technological and scientific advancements.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>To impart quality technical education, foster research and innovation, and nurture skilled engineers who can address global challenges and contribute to the progress of society.</span>
                </li>
            </ul>
        </motion.div>
    </div>
);


const WhySection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <BookOpen className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">Why Choose Maya Devi University – The Best Engineering College in Dehradun? </h4>
        </div>
        <div className="space-y-4 text-gray-700">
            <p>Maya Devi University is a premier engineering institution, committed to nurturing innovative minds and shaping future technology leaders. With a strong emphasis on academic excellence, research, and industry collaboration, we offer a diverse range of undergraduate and postgraduate programs in cutting-edge engineering disciplines.
            </p>
            <h6>Key Highlights of Our Engineering Programs</h6>
            <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>State-of-the-Art Infrastructure – Advanced laboratories, high-tech research centers, and innovation hubs. </span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span> Industry-Oriented Curriculum – Designed to align with modern technological advancements.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Expert Faculty & Mentors – Learn from experienced academicians and industry specialists.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span> Extensive Industry Collaborations – Strong partnerships with leading companies for real-world exposure.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span> Hands-On Learning Approach – Practical training, industrial visits, and live projects.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Global Networking Opportunities – Collaborate with international universities and research institutions.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>  Skill Development & Career Growth – Focus on leadership, innovation, and professional development.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span> Affordable Fees & Scholarships – Ensuring quality education with financial support.</span>
                </li>
            </ul>
            {/* <p>The 21st century is marked by rapid innovation, and exposure to engineering allows students to stay at the forefront of modern technological trends. Engineering plays a vital role in solving real-world problems, offering practical solutions that address the needs of society. As long as humanity continues to evolve, the demand for skilled engineers remains essential.  </p>

            <p>Upon graduation, engineers have access to a broad spectrum of career opportunities, whether in traditional engineering roles or in entrepreneurial ventures, enabling them to innovate and contribute to society in multiple  ways.
            </p> */}
        </div>
    </motion.div>
);

const LearningExperience = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <BookOpen className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">A Holistic Learning Experience at Maya Devi University</h4>
        </div>
        <div className="space-y-4 text-gray-700">
            <p>As the Best Engineering College in Dehradun, Maya Devi University is dedicated to providing a holistic learning experience that prepares students for success in an ever-evolving technological landscape. Our distinguished faculty members focus on developing students who are passionate about serving society through innovative technology while also possessing strong interpersonal and leadership skills.</p>

            <h6>We offer a diverse range of academic and industry-focused opportunities, including:</h6>
            <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Expert Talks & Seminars – Insights from industry leaders and experienced professionals.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span> Workshops & Training Programs – Hands-on learning experiences in specialized fields.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Industrial Visits & Internships – Exposure to real-world engineering applications.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span> Engineering Exhibitions & Projects – Showcasing student innovations and research breakthroughs.</span>
                </li>
            </ul>

            <p>With technological advancements reshaping industries, we actively create platforms for students to showcase their engineering innovations through exhibitions and hands-on projects. This practical exposure allows students to learn, grow, and shape the future of engineering.
                <br />
                Join the Best Engineering College in Dehradun – <Link to="https://admission.maya.edu.in/"> <strong>Apply Today !</strong></Link>
                <br />
                <br />
                Take the next step in your engineering career with Maya Devi University, the Best Engineering College in Dehradun. Gain world-class education, expert mentorship, and industry exposure to excel in the field of engineering and technology.
                <br />
                <br />
                <Link to="https://admission.maya.edu.in/"> <strong>Apply Now</strong></Link> and become a part of an institution that is transforming engineering education and innovation!
            </p>

        </div>
    </motion.div>
);

const WhatSection = () => (
    <motion.div
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <Flag className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">What makes School of Engineering at Maya Devi University unique? </h4>
        </div>
        <ul className="space-y-3 text-gray-700">
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>The Faculty of Engineering offers a range of programs that incorporate cutting-edge techniques, providing students with a comprehensive engineering education. </span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>We prioritize systematic evaluation and feedback to support continuous learning and improvement. </span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>To inspire and motivate students, the faculty creates various platforms where they can cultivate their creativity and innovation. </span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Additionally, our strategic international partnerships offer students valuable opportunities for global exposure and participation  in collaborative research projects with leading institutions.  </span>
            </li>
        </ul>
    </motion.div>
);


const CourseCard = ({ course, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.1 }}
        className="group w-full"
    >
        <Link to={course.path}>
            <div className="bg-white p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col justify-between gap-3">
                <div>
                    <div className="flex justify-between items-start">
                        <div className="p-2 bg-blue-50 rounded-lg">
                            <GraduationCap className="w-5 h-5 text-blue-600" />
                        </div>
                        <motion.div
                            whileHover={{ scale: 1.1 }}
                            className="p-2 rounded-full hover:bg-gray-100"
                        >
                            <ArrowUpRight className="w-4 h-4 text-gray-400 group-hover:text-[#0e4d38]" />
                        </motion.div>
                    </div>
                    <h3 className="text-base md:text-lg font-semibold mt-3 text-gray-800 group-hover:text-[#0e4d38] transition-colors">
                        {course.name}
                    </h3>
                </div>
                <div className="flex items-center gap-3 text-xs text-gray-500 mt-2">
                    <div className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        <span>{course.name.includes('Master') ? '2 Years' : '4 Years'}</span>
                    </div>
                    <div className="flex items-center gap-1">
                        <Bookmark className="w-3 h-3" />
                        <span>{course.name.includes('Master') ? 'PG' : 'UG'}</span>
                    </div>
                </div>
            </div>
        </Link>
    </motion.div>
);

const Department = ({ title, icon, courses }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {courses.map((course, index) => (
                <CourseCard key={index} course={course} index={index} />
            ))}
        </div>
    </motion.div>
);

const FeatureList = ({ title, items, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-xl text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {items.map((item, index) => (
                <motion.div
                    key={index}
                    className="p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300"
                    whileHover={{ scale: 1.02 }}
                >
                    <div className="flex items-start gap-2">
                        <div className="w-2 h-2 mt-1.5 bg-[#23376c] rounded-full flex-shrink-0" />
                        <span className="text-gray-700 text-xs md:text-sm">{item}</span>
                    </div>
                </motion.div>
            ))}
        </div>
    </motion.div>
);

const HeroSection = () => (
    <div className="relative overflow-hidden bg-[#0e4d38] text-white py-8 md:py-16 px-4 md:px-6 rounded-xl mb-6 md:mb-8 mt-16 md:mt-20">
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-5xl"
        >
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-4">
                Best Engineering College in Dehradun – Maya Devi University
            </h1>
            <h6 className="font-bold mb-3 md:mb-4">
                Shaping Future Engineers with Excellence
            </h6>
            <p className="text-sm text-gray-200 mb-4 md:mb-6">
                Engineering is one of the most foundational fields of technical study, playing a crucial role in setting global standards of excellence across various disciplines of science and technology. It has significantly contributed to societal progress, driving countless innovations and improving human welfare.<br />
                At Maya Devi University, the Best Engineering College in Dehradun, we are dedicated to shaping and nurturing the next generation of engineers and technical experts. Our Faculty of Engineering and Technology ensures that students not only drive technological advancements but also make meaningful contributions to life sciences, infrastructure, and beyond. At the core of engineering education is innovation, and we empower our students to tackle real-world challenges and develop groundbreaking solutions.

            </p>
            <Link to="https://admission.maya.edu.in/">
                <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="bg-white text-[#0e4d38] px-4 md:px-6 py-2 md:py-3 rounded-full text-sm md:text-base font-semibold flex items-center gap-2 group"
                >
                    Apply Now
                    <Rocket className="w-3 h-3 md:w-4 md:h-4 group-hover:translate-x-1 transition-transform" />
                </motion.button>
            </Link>
        </motion.div>
    </div>
);

const Engineering = () => {
    return (
        <div className="min-h-screen bg-gray-50 font-poppins">
            <Title canonicalPath="/programmes/ug-courses/best-engineering-college-in-dehradun-uttarakhand" />
            <Title title="Top Engineering Colleges in Dehradun | Best Institutes" description=" Discover the top engineering colleges in Dehradun. Explore premier institutes offering quality education, modern infrastructure, and great placement opportunities." />
            <div className="max-w-7xl mx-auto pt-16 md:pt-20 pb-8 md:pb-16 px-4 space-y-6 md:space-y-8">
                <HeroSection />
                <Stats />
                <AboutSection />
                <WhySection />
                <LearningExperience />
                <WhatSection />
                <VisionMissionSection />
                <div className="space-y-6 md:space-y-8">
                    {/* <Department
                        title="Diploma Programs"
                        icon={<MonitorPlay className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={DiplomaPrograms}
                    /> */}
                    <Department
                        title="Undergraduate Programs"
                        icon={<Building className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={undergraduatePrograms}
                    />
                    <Department
                        title="Postgraduate Programs"
                        icon={<Wrench className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={PostgraduatePrograms}
                    />
                </div>

                <div className="space-y-6 md:space-y-8">
                    <FeatureList
                        title="USPs"
                        icon={<Stars className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Industry-Relevant Curriculum designed by Core Academia & Renowned Industry Experts",
                            "Renowned Domain Specific & Highly Rich Experienced Faculty",
                            "State-of-the-art infrastructure including computer labs",
                            "Centre of Excellence in Specific Domain & Technology",
                            "Continuous learning and skill enhancement",
                            "Hands-On Learning through practical projects",
                            "Live Industry Projects based Learning",
                            "Global Recognition and accreditation",
                            "LMS based Pedagogy",
                            "Choice Based Credit System (CBCS)",
                            "Industry Collaborations and Internships",
                            "Full-Time Industrial Internship",
                            "Entrepreneurship programs and incubation centres"
                        ]}
                    />

                    <FeatureList
                        title="Career Options"
                        icon={<Briefcase className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Cloud Computing Specialist",
                            "Data Scientist/Data Analyst",
                            "AI/ML Engineer",
                            "Cybersecurity Analyst",
                            "Software Developer",
                            "Database Administrator",
                            "Network Engineer",
                            "IT Consultant",
                            "Systems Analyst",
                            "Web Developer",
                            "Software Engineer"
                        ]}
                    />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Engineering;



// import React, { useState, useEffect } from 'react';
// import { motion } from 'framer-motion';
// import Footer from '../../../components/Footer';
// import {
//     BookOpen,
//     Award,
//     Users,
//     Globe,
//     Target,
//     Flag,
//     GraduationCap,
//     Briefcase,
//     ArrowUpRight,
//     Clock,
//     Bookmark,
//     Share2,
//     Building,
//     Rocket,
//     Stars,
//     Wrench,
//     CheckCircle,
//     MonitorPlay,
//     ChevronRight,
//     ArrowRight,
//     Zap,
//     Shield,
//     Code,
//     Database,
//     Server,
//     LucideSearch,
//     Activity,
//     MessageSquareQuote
// } from 'lucide-react';
// import { Link } from 'react-router-dom';
// import Title from '../../../components/TitleComponent';
// import overview from '../../../assets/schools/computer/comp1.jpg';
// import why from '../../../assets/schools/computer/comp2.jpg';
// import dean from '../../../assets/schools/computer/dean_rb_singh.png';
// import prashant from '../../../assets/schools/computer/prashant.jpg';
// import sonu from '../../../assets/schools/computer/sonu.jpg';

// // Program Data
// const undergraduatePrograms = [
//     {
//         name: "Bachelor of Technology in Cloud Computing and Engineering",
//         path: "/programmes/ug-courses/engineering/btech/cloud-computing-engineering"
//     },
//     {
//         name: "Bachelor of Technology in Data Science and Engineering",
//         path: "/programmes/ug-courses/engineering/btech/data-science-engineering"
//     },
//     {
//         name: "Bachelor of Technology in Cyber Security and Engineering",
//         path: "/programmes/ug-courses/engineering/btech/cybersecurity-engineering"
//     },
//     {
//         name: "Bachelor of Technology in Artificial Intelligence Machine Learning and Engineering",
//         path: "/programmes/ug-courses/engineering/btech/ai-ml"
//     },
//     {
//         name: "Bachelor of Technology in Civil Engineering",
//         path: "/programmes/ug-courses/engineering/btech/civil-engineering"
//     },
//     {
//         name: "Bachelor of Technology in Computer Science and Engineering",
//         path: "/programmes/ug-courses/engineering/btech/computer-science-engineering"
//     },
//     {
//         name: "Bachelor of Technology in Mechanical Engineering",
//         path: "/programmes/ug-courses/engineering/btech/mechanical-engineering"
//     },
// ];

// // Component for animated stats counter
// const AnimatedCounter = ({ value, label, icon, color }) => {
//     const [count, setCount] = useState(0);

//     useEffect(() => {
//         const duration = 2000; // 2 seconds duration for the count animation
//         const frameDuration = 1000 / 60; // 60fps
//         const totalFrames = Math.round(duration / frameDuration);
//         const increment = parseInt(value) / totalFrames;

//         let currentFrame = 0;
//         const counter = setInterval(() => {
//             currentFrame++;
//             setCount(Math.min(Math.round(increment * currentFrame), parseInt(value)));

//             if (currentFrame === totalFrames) {
//                 clearInterval(counter);
//             }
//         }, frameDuration);

//         return () => clearInterval(counter);
//     }, [value]);

//     return (
//         <motion.div
//             className={`${color} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300`}
//             whileHover={{ scale: 1.02 }}
//         >
//             <div className="text-[#0e4d38]">{icon}</div>
//             <h3 className="text-xl md:text-3xl font-bold mt-2 text-gray-800">{count}+</h3>
//             <p className="text-gray-600 text-sm md:text-base">{label}</p>
//         </motion.div>
//     );
// };

// // Components
// const HeroSection = () => (
//     <div className="relative overflow-hidden bg-gradient-to-r from-[#0e4d38] to-[#23376c] text-white py-12 md:py-20 px-6 md:px-10 rounded-xl mb-8 md:mb-12">
//         <div className="absolute inset-0 bg-[url('/api/placeholder/1600/800')] bg-cover bg-center opacity-10 mix-blend-overlay" aria-hidden="true"></div>
//         <div className="absolute -right-20 -bottom-20 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl" aria-hidden="true"></div>
//         <div className="absolute -left-20 -top-20 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl" aria-hidden="true"></div>

//         <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="max-w-6xl mx-auto relative z-10"
//         >
//             <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6">
//                 School of Computer Engineering & Applications
//             </h1>
//             <h2 className="text-xl md:text-2xl font-semibold mb-6 md:mb-8 text-green-100">
//                 Shaping Tomorrow's Digital Leaders at Maya Devi University
//             </h2>

//             <div className="flex flex-wrap gap-4 md:gap-6">
//                 <Link to="https://admission.maya.edu.in/">
//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         className="bg-white text-[#0e4d38] px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold flex items-center gap-2 group shadow-lg"
//                     >
//                         Apply Now
//                         <Rocket className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
//                     </motion.button>
//                 </Link>
//                 {/* <Link to="#programs">
//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         className="bg-transparent border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold flex items-center gap-2 group"
//                     >
//                         Explore Programs
//                         <ArrowRight className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
//                     </motion.button>
//                 </Link> */}
//             </div>
//         </motion.div>
//     </div>
// );

// const Stats = () => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 my-8 md:my-12 px-4"
//     >
//         <AnimatedCounter
//             icon={<Users className="w-8 h-8 md:w-10 md:h-10" />}
//             value="8"
//             label="Programs Offered"
//             color="bg-blue-50"
//         />
//         <AnimatedCounter
//             icon={<Award className="w-8 h-8 md:w-10 md:h-10" />}
//             value="1000"
//             label="Students Placed"
//             color="bg-green-50"
//         />
//         <AnimatedCounter
//             icon={<Briefcase className="w-8 h-8 md:w-10 md:h-10" />}
//             value="48"
//             label="Highest Package (LPA)"
//             color="bg-purple-50"
//         />
//         <AnimatedCounter
//             icon={<Globe className="w-8 h-8 md:w-10 md:h-10" />}
//             value="100"
//             label="Industry Partners"
//             color="bg-orange-50"
//         />
//     </motion.div>
// );

// const SchoolOverview = () => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="bg-white p-8 rounded-xl shadow-lg mb-12"
//     >
//         <div className="flex flex-col lg:flex-row gap-8 items-center">
//             <div className="w-full lg:w-1/2">
//                 <div className="flex items-center gap-3 mb-6">
//                     <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                         <BookOpen className="w-6 h-6" />
//                     </div>
//                     <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">School Overview</h2>
//                 </div>
//                 <div className="space-y-4 text-gray-700 text-lg">
//                     <p>The School of Computer Applications at Maya Devi University is dedicated to shaping the future of technology by blending academic excellence with ethical responsibility. Anchored in a vision to be a leading center of innovation and knowledge, the School empowers students to become globally responsible digital leaders—equipped with technical expertise, creative problem-solving skills, and a strong moral compass.</p>
//                     <p>Our programs are designed to foster a dynamic learning environment that promotes
//                         innovation, critical thinking, and lifelong learning. We seamlessly integrate
//                         emerging technologies with core human values to ensure our graduates are not
//                         only proficient in cutting-edge tools but also driven by integrity, compassion, and a
//                         commitment to social good.
//                     </p>
//                     <p>Through a global perspective, hands-on experiences, and a focus on sustainability
//                         and inclusivity, the School prepares students to address real-world challenges and
//                         shape a better, tech-enabled future for all.

//                     </p>
//                 </div>
//             </div>
//             <div className="w-full lg:w-1/2 relative h-80 md:h-96 rounded-xl overflow-hidden shadow-xl">
//                 <img
//                     src={overview}
//                     alt="School of Computer Applications"
//                     className="w-full h-full object-cover rounded-xl transition-transform duration-700 hover:scale-105"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-[#0e4d38]/70 to-transparent flex items-end">
//                     <div className="p-6">
//                         <h3 className="text-white text-xl font-bold">Cutting-edge Learning Environment</h3>
//                         <p className="text-white/80 text-sm">Modern classrooms and advanced computer labs</p>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </motion.div>
// );

// const WhyUsSection = () => {
//     const features = [
//         {
//             icon: <Zap className="w-7 h-7" />,
//             title: "Excellence in Education & Innovation",
//             description: "We offer a future-ready curriculum that combines deep theoretical knowledge with practical, hands-on experience in cutting-edge technologies such as AI, cyber security, data science, cloud computing, and more."
//         },
//         {
//             icon: <Shield className="w-7 h-7" />,
//             title: "Ethics Meets Technology",
//             description: "Our programs emphasize not just what you can build, but what you should build—instilling strong ethical values and social responsibility in every technologist we shape."
//         },
//         {
//             icon: <Globe className="w-7 h-7" />,
//             title: "Global Readiness",
//             description: "We prepare you for a connected world with industry exposure, international collaborations, and real-world projects that enhance your global perspective and professional agility."
//         },
//         {
//             icon: <LucideSearch className="w-7 h-7" />,
//             title: "Research & Creativity",
//             description: "Whether you're passionate about academic research or innovative product development, you'll have opportunities to explore, create, and solve problems that matter."
//         },
//         {
//             icon: <Users className="w-7 h-7" />,
//             title: "Supportive, Inclusive Environment",
//             description: "We foster a diverse and inclusive learning culture where every voice is heard and every student is empowered to grow—personally, academically, and professionally."
//         },
//         {
//             icon: <Activity className="w-7 h-7" />,
//             title: "Commitment to Lifelong Learning",
//             description: "In a fast-evolving tech world, we help you build not just a degree, but a mindset of continuous growth, critical thinking, and lifelong curiosity."
//         }
//     ];

//     return (
//         <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-8 rounded-xl shadow-lg mb-12"
//         >
//             <div className="flex flex-col md:flex-row gap-8">
//                 <div className="w-full md:w-1/3">
//                     <div className="sticky top-24">
//                         <div className="flex items-center gap-3 mb-4">
//                             <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                                 <CheckCircle className="w-6 h-6" />
//                             </div>
//                             <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Why Choose Us?</h2>
//                         </div>
//                         <p className="text-gray-700 mb-6">Choosing the right place to pursue your education is a life-changing decision. Here's why the School of Computer Applications at Maya Devi University stands out:</p>
//                         <div className="relative h-60 md:h-80 rounded-lg overflow-hidden">
//                             <img
//                                 src={why}
//                                 alt="Students collaborating"
//                                 className="w-full h-full object-cover"
//                             />
//                             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0e4d38] to-transparent p-4">
//                                 <p className="text-white font-semibold">Ready to become a responsible, visionary leader in tech? Join us—and build the future with purpose.</p>
//                             </div>
//                         </div>
//                         <div className="mt-6">
//                             <Link to="https://admission.maya.edu.in/">
//                                 <motion.button
//                                     whileHover={{ scale: 1.02 }}
//                                     whileTap={{ scale: 0.98 }}
//                                     className="w-full bg-[#0e4d38] text-white px-6 py-3 rounded-lg text-lg font-semibold flex items-center justify-center gap-2"
//                                 >
//                                     Apply Now
//                                     <ArrowRight className="w-5 h-5" />
//                                 </motion.button>
//                             </Link>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="w-full md:w-2/3">
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                         {features.map((feature, index) => (
//                             <motion.div
//                                 key={index}
//                                 initial={{ opacity: 0, y: 20 }}
//                                 whileInView={{ opacity: 1, y: 0 }}
//                                 viewport={{ once: true }}
//                                 transition={{ delay: index * 0.1 }}
//                                 className="bg-gray-50 p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
//                             >
//                                 <div className="text-[#0e4d38] mb-4">
//                                     <div className="p-3 bg-[#0e4d38]/10 rounded-lg inline-block">
//                                         {feature.icon}
//                                     </div>
//                                 </div>
//                                 <h3 className="text-xl font-bold mb-3 text-gray-800">{feature.title}</h3>
//                                 <p className="text-gray-600">{feature.description}</p>
//                             </motion.div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </motion.div>
//     );
// };

// const TopRecruiters = () => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="bg-white p-8 rounded-xl shadow-lg mb-12"
//     >
//         <div className="flex items-center gap-3 mb-8">
//             <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                 <Briefcase className="w-6 h-6" />
//             </div>
//             <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Top Recruiters</h2>
//         </div>

//         <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
//             {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item, index) => (
//                 <motion.div
//                     key={index}
//                     initial={{ opacity: 0, scale: 0.9 }}
//                     whileInView={{ opacity: 1, scale: 1 }}
//                     viewport={{ once: true }}
//                     transition={{ delay: index * 0.05 }}
//                     className="bg-gray-50 p-4 rounded-lg flex items-center justify-center h-24 shadow-sm hover:shadow-md transition-all duration-300"
//                 >
//                     <img
//                         src={`/api/placeholder/200/80`}
//                         alt={`Company logo ${item}`}
//                         className="max-h-16 max-w-full object-contain"
//                     />
//                 </motion.div>
//             ))}
//         </div>
//     </motion.div>
// );

// const ClubsAndSocieties = () => {
//     const clubs = [
//         {
//             name: "AI & Robotics Society",
//             icon: <Rocket className="w-6 h-6" />,
//             color: "bg-blue-50"
//         },
//         {
//             name: "CyberSec Club",
//             icon: <Shield className="w-6 h-6" />,
//             color: "bg-red-50"
//         },
//         {
//             name: "Web & App Developers Hub",
//             icon: <Code className="w-6 h-6" />,
//             color: "bg-green-50"
//         },
//         {
//             name: "Data Verse – Data Science Community",
//             icon: <Database className="w-6 h-6" />,
//             color: "bg-purple-50"
//         },
//         {
//             name: "Tech4Good Society",
//             icon: <Globe className="w-6 h-6" />,
//             color: "bg-teal-50"
//         },
//         {
//             name: "TechTalks & Toastmasters",
//             icon: <Users className="w-6 h-6" />,
//             color: "bg-amber-50"
//         },
//         {
//             name: "Game Dev & AR/VR Club",
//             icon: <Server className="w-6 h-6" />,
//             color: "bg-indigo-50"
//         }
//     ];

//     return (
//         <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-8 rounded-xl shadow-lg mb-12"
//         >
//             <div className="flex items-center gap-3 mb-8">
//                 <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                     <Users className="w-6 h-6" />
//                 </div>
//                 <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Clubs & Societies</h2>
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//                 {clubs.map((club, index) => (
//                     <motion.div
//                         key={index}
//                         initial={{ opacity: 0, y: 20 }}
//                         whileInView={{ opacity: 1, y: 0 }}
//                         viewport={{ once: true }}
//                         transition={{ delay: index * 0.1 }}
//                         className={`${club.color} p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300`}
//                     >
//                         <div className="flex items-center gap-4">
//                             <div className="p-3 bg-white rounded-lg shadow-md">
//                                 {club.icon}
//                             </div>
//                             <h3 className="text-lg font-semibold text-gray-800">{club.name}</h3>
//                         </div>
//                     </motion.div>
//                 ))}
//             </div>
//         </motion.div>
//     );
// };

// const DeansWelcome = () => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="bg-white p-8 rounded-xxl shadow-lg mb-12"
//     >
//         <div className="flex flex-col md:flex-row gap-8">
//             <div className="w-full md:w-1/3">
//                 <div className="rounded-xl overflow-hidden shadow-xl">
//                     <img
//                         src={dean}
//                         alt="Dean of School of Computer Applications"
//                         className="w-full h-auto"
//                     />
//                 </div>
//             </div>
//             <div className="w-full md:w-2/3">
//                 <div className="flex items-center gap-3 mb-6">
//                     <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                         <Award className="w-6 h-6" />
//                     </div>
//                     <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Dean's Welcome Note</h2>
//                 </div>
//                 <div className="space-y-4 text-gray-700">
//                     <p className="text-lg italic">"Dear Students, Faculty, and Visitors,"</p>
//                     <p>It is my pleasure to welcome you to the School of Computer Science and
//                         Applications at Maya Devi University—a place where innovation meets integrity,
//                         and technology is shaped with purpose.
//                     </p>
//                     <p>In today’s rapidly evolving digital world, we believe that technical excellence must
//                         go hand in hand with ethical responsibility and human values. Our School is
//                         committed to empowering students not just with the latest skills and knowledge in
//                         computer science, but with the creativity, critical thinking, and moral compass
//                         needed to lead with impact on a global scale.
//                     </p>
//                     <p>Here, you will find a vibrant academic environment that nurtures innovation,
//                         fosters interdisciplinary learning, and encourages lifelong curiosity. Whether you
//                         aspire to become a software engineer, a researcher, an entrepreneur, or a socially
//                         conscious tech leader, we are here to support your journey and help you thrive in a
//                         future defined by change.
//                     </p>
//                     <p>We invite you to explore, learn, collaborate, and grow with us as we work together
//                         to shape a more inclusive, sustainable, and technologically empowered world.

//                     </p>
//                     <p className="font-semibold">Together, let's build technology that makes our world better.</p>
//                     <p className="font-bold text-[#0e4d38]">Warm regards,</p>
//                     <p className="font-bold text-[#0e4d38]">Prof. Dr. R B Singh</p>
//                     <p className="text-gray-600">Dean, School of Computer Science and Applications<br />Maya Devi University</p>
//                 </div>
//             </div>
//         </div>
//     </motion.div>
// );

// const CourseCard = ({ course, index }) => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         transition={{ delay: index * 0.1 }}
//         className="group w-full"
//     >
//         <Link to={course.path}>
//             <div className="bg-white p-5 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col justify-between gap-3">
//                 <div>
//                     <div className="flex justify-between items-start">
//                         <div className="p-3 bg-blue-50 rounded-lg">
//                             <GraduationCap className="w-5 h-5 text-blue-600" />
//                         </div>
//                         <motion.div
//                             whileHover={{ scale: 1.1 }}
//                             className="p-2 rounded-full hover:bg-gray-100"
//                         >
//                             <ArrowUpRight className="w-4 h-4 text-gray-400 group-hover:text-[#0e4d38]" />
//                         </motion.div>
//                     </div>
//                     <h3 className="text-lg font-semibold mt-3 text-gray-800 group-hover:text-[#0e4d38] transition-colors line-clamp-2">
//                         {course.name}
//                     </h3>
//                 </div>
//                 <div className="flex items-center gap-3 text-sm text-gray-500">
//                     <div className="flex items-center gap-1">
//                         <Clock className="w-4 h-4" />
//                         <span>{course.name.includes('Master') ? '2 Years' : '4 Years'}</span>
//                     </div>
//                     <div className="flex items-center gap-1">
//                         <Bookmark className="w-4 h-4" />
//                         <span>{course.name.includes('Master') ? 'PG' : 'UG'}</span>
//                     </div>
//                 </div>
//             </div>
//         </Link>
//     </motion.div>
// );

// const ProgramsSection = () => (
//     <motion.div
//         id="programs"
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="bg-white p-8 rounded-xl shadow-lg mb-12"
//     >
//         <div className="flex items-center gap-3 mb-8">
//             <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                 <GraduationCap className="w-6 h-6" />
//             </div>
//             <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Our Programs</h2>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//             {undergraduatePrograms.slice(0, 6).map((course, index) => (
//                 <CourseCard key={index} course={course} index={index} />
//             ))}
//         </div>
//     </motion.div>
// );

// const CTASection = () => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="relative overflow-hidden bg-gradient-to-r from-[#0e4d38] to-[#23376c] text-white py-12 px-8 rounded-xl mb-12"
//     >
//         <div className="absolute inset-0 bg-[url('/api/placeholder/1600/800')] bg-cover bg-center opacity-10 mix-blend-overlay"></div>
//         <div className="absolute -right-20 -bottom-20 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl"></div>

//         <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
//             <div>
//                 <h2 className="text-2xl md:text-3xl font-bold mb-4">Ready to Shape Your Digital Future?</h2>
//                 <p className="text-white/80 max-w-xl">Join the School of Computer Applications at Maya Devi University and become part of a community dedicated to innovation, excellence, and responsible technology leadership.</p>
//             </div>
//             <div className="flex flex-col sm:flex-row gap-4">
//                 <Link to="https://admission.maya.edu.in/">
//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         className="bg-white text-[#0e4d38] px-8 py-4 rounded-lg text-lg font-semibold flex items-center gap-2 shadow-lg whitespace-nowrap"
//                     >
//                         Apply Now
//                         <Rocket className="w-5 h-5" />
//                     </motion.button>
//                 </Link>
//                 {/* <Link to="#programs">
//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold flex items-center gap-2 whitespace-nowrap"
//                     >
//                         View Programs
//                         <ChevronRight className="w-5 h-5" />
//                     </motion.button>
//                 </Link> */}
//             </div>
//         </div>
//     </motion.div>
// );


// // 
// const TestimonialCard = ({ student, index }) => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         transition={{ delay: index * 0.2 }}
//         className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col h-full"
//     >
//         <div className="bg-gradient-to-r from-[#0e4d38]/10 to-[#23376c]/10 p-4">
//             <div className="flex items-center gap-3">
//                 <div className="w-14 h-14 rounded-full bg-gray-200 overflow-hidden">
//                     <img
//                         src={student.image}
//                         alt={student.name}
//                         className="w-full h-full object-cover"
//                     />
//                 </div>
//                 <div>
//                     <h3 className="font-bold text-lg text-gray-800">{student.name}</h3>
//                     <div className="flex items-center gap-1 text-sm text-gray-600">
//                         <Building className="w-3 h-3" />
//                         <span>{student.company}</span>
//                     </div>
//                 </div>
//             </div>
//         </div>

//         <div className="p-6 flex-1 flex flex-col">
//             <div className="text-[#0e4d38] mb-3">
//                 <MessageSquareQuote className="w-6 h-6" />
//             </div>
//             <p className="text-gray-700 italic flex-1">{student.testimonial}</p>

//             <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
//                 {student.award && (
//                     <div className="flex items-center gap-1 text-sm text-gray-600">
//                         <Award className="w-4 h-4 text-[#0e4d38]" />
//                         <span>{student.award}</span>
//                     </div>
//                 )}
//                 <div className="text-sm text-gray-500">Class of {student.graduationYear}</div>
//             </div>
//         </div>
//     </motion.div>
// );

// const StudentTestimonials = () => {
//     const testimonials = [
//         {
//             name: "Tamanna",
//             company: "Amazon",
//             graduationYear: "2024",
//             award: "Excellence Award",
//             testimonial: "Studying at Maya Devi University has been one of the most transformative experiences of my life. The university not only provided a strong academic foundation but also fostered a culture of innovation, critical thinking, and continuous learning."
//         },
//         {
//             name: "Prashant Bharti Rajak",
//             company: "Nielsen",
//             graduationYear: "2023",
//             image: prashant,
//             testimonial: "My university journey has been transformative, largely thanks to the supportive environment and excellent infrastructure. Access to well-equipped labs, smart classrooms, a comprehensive library, and high-speed internet kept me aligned with industry trends—playing a key role in securing my placement at Nielsen."
//         },
//         {
//             name: "Sonu Thapa",
//             company: "Ayavin",
//             graduationYear: "2024",
//             award: "Innovation Scholar",
//             image: sonu,
//             testimonial: "I am incredibly grateful to Maya Devi University for shaping me into the professional I am today. The knowledge, skills, and values I gained here played a vital role in helping me secure a position at Ayavin. Throughout my academic journey, I received constant support from my professors, access to industry-relevant coursework, and opportunities to engage in hands-on learning. The university's focus on practical application and real-world problem-solving gave me the confidence to take on challenges in a professional setting."
//         }
//     ];

//     return (
//         <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-8 rounded-xl shadow-lg mb-12"
//         >
//             <div className="flex items-center gap-3 mb-8">
//                 <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                     <Users className="w-6 h-6" />
//                 </div>
//                 <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Student Testimonials</h2>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//                 {testimonials.map((testimonial, index) => (
//                     <TestimonialCard
//                         key={index}
//                         student={testimonial}
//                         index={index}
//                     />
//                 ))}
//             </div>
//         </motion.div>
//     );
// };

// const SchoolOfComputerApplications = () => {
//     return (
//         <div className="min-h-screen bg-gray-50 font-poppins mt-[70px]">
//             <Title canonicalPath="/programmes/ug-courses/school-of-computer-applications" />
//             <Title title="School of Computer Applications | Maya Devi University" description="Explore cutting-edge computer application programs at Maya Devi University. Become a technology leader with our innovative curriculum, expert faculty, and industry partnerships." />

//             <div className="max-w-7xl mx-auto pt-16 md:pt-20 pb-8 md:pb-16 px-4 space-y-6 md:space-y-8">
//                 <HeroSection />
//                 <Stats />
//                 <SchoolOverview />
//                 <WhyUsSection />
//                 {/* <TopRecruiters /> */}
//                 <ClubsAndSocieties />
//                 <DeansWelcome />
//                 <ProgramsSection />
//                 <StudentTestimonials />
//                 <CTASection />
//             </div>
//             <Footer />
//         </div>
//     );
// };

// export default SchoolOfComputerApplications;